import { get, post, put, patch } from "../Config"

export function SearchWhatWeDo({ params = {}, lang }) {
  return get({ url: `/v1/admin/what-we-do`, params, lang })
}
export function GetWhatWeDoById({ id, lang }) {
  return get({ url: `/v1/admin/what-we-do/${id}`, lang })
}
export function CreateWhatWeDo({ params = {}, data = {}, lang }) {
  return post({ url: `/v1/admin/what-we-do`, params, data, lang })
}
export function UpdateWhatWeDo({ params = {}, data = {} , id, lang }) {
  return put({ url: `/v1/admin/what-we-do/${id}`, params, data, lang })
}
export function PatchWhatWeDo({ params = {}, data = {} , id, lang }) {
  return patch({ url: `/v1/admin/what-we-do/${id}`, params, data, lang })
}
export function DeleteWhatWeDo({ params = {}, data = {}, lang }) {
  return post({ url: `/v1/admin/what-we-do/mutiDelete`, params, data, lang })
}
